module.exports = __webpack_public_path__ + "static/media/SREEMANGAL.6d0300f1.png";